import { useCallback, useEffect, useRef, useState } from 'react';
export const useDebounce = (callback, delay) => {
    const [isDebouncing, setIsDebouncing] = useState(false);
    const timeoutRef = useRef(null);
    useEffect(() => {
        // Cleanup the previous timeout on re-render
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const debouncedCallback = useCallback((...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsDebouncing(true);
        timeoutRef.current = setTimeout(() => {
            setIsDebouncing(false);
            callback(...args);
        }, delay);
    }, [callback, delay]);
    return { debouncedCallback, isDebouncing };
};
//# sourceMappingURL=useDebounce.js.map